/*
 * @Autor: dingxiaolin
 * @Date: 2021-01-05 14:03:07
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-09-22 14:04:07
 */
var OSS = require('ali-oss');
import Bus from './bus';
import store from '../../vuex';
store.commit('judgeDomain')
store.dispatch('setOssInfo')
const aliupload=()=>{
    /**声明 */
    var client = new OSS.Wrapper({
        /* sino */
        region: 'oss-cn-hangzhou',
        secure: true,
        accessKeyId: store.state.ossInfo.tempAccessKeyId,
        accessKeySecret: store.state.ossInfo.tempAccessKeySecret,
        bucket: 'hfto',
        stsToken:store.state.ossInfo.tempSecurityToken
    });
    
    /**上传图片**/
    var upload = async function (file, name, path = "") {
        await store.dispatch('setOssInfo')
        let filetype = name.substring(name.lastIndexOf('.') + 1);
        var storeAs = 'pos/' + path + getUuid() + '.' + filetype;
        try {
            return await client.multipartUpload(storeAs, file, {
                progress: progress
            });
        } catch (error) {
            console.log(error);
        }
    };
    /**上传图片流**/
    var uploadStream = async function (urlData, cb) {
        await store.dispatch('setOssInfo')
        function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
    
            return new Blob([ab], { type: 'image/png' });
        }
        var blob = convertBase64UrlToBlob(urlData);
        if (blob.size > 0) {
            // blob转arrayBuffer
            var reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = e => {
                // 文件名
                var storeAs = 'pos/' + getUuid() + '.' + blob.type.split('/')[1];
                // arrayBuffer转Buffer
                var buffer = new OSS.Buffer(e.target.result);
                // 上传
                client
                    .put(storeAs, buffer)
                    .then(result => {
                        cb(result);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            };
        }
    };
    /**上传图片流**/
    var uploadBlob = async function (blob, cb) {
        await store.dispatch('setOssInfo')
        // var blob = convertBase64UrlToBlob(urlData);
        if (blob.size > 0) {
            // blob转arrayBuffer
            var reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = e => {
                // 文件名
                var storeAs = 'pos/' + getUuid() + '.' + blob.type.split('/')[1];
                // arrayBuffer转Buffer
                var buffer = new OSS.Buffer(e.target.result);
                // 上传
                client
                    .put(storeAs, buffer)
                    .then(result => {
                        cb(result);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            };
        }
    };
    /**上传文件流**/
    var uploadFileStream = async function (urlData,style, cb) {
        await store.dispatch('setOssInfo')
        function convertBase64UrlToBlob(urlData) {
            var bytes = urlData; //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            if(style == 'png'){
                return new Blob([ab], { type: 'image/png' });
            }else if(style == 'jpg'){
                return new Blob([ab], { type: 'application/jpg' });
            }else {
                return new Blob([ab], { type: `application/${style}` });
            }
        }
        var blob = convertBase64UrlToBlob(urlData);
        if (blob.size > 0) {
            // blob转arrayBuffer
            var reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = e => {
                // 文件名
                var storeAs = 'pos/' + getUuid() + '.' + blob.type.split('/')[1];
                // arrayBuffer转Buffer
                var buffer = new OSS.Buffer(e.target.result);
                // 上传
                client
                    .put(storeAs, buffer)
                    .then(result => {
                        cb(result);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            };
        }
    };
    /**上传进度 */
    var progress = function (p) {
        return function (done) {
            Bus.$emit('progress', Math.round(p * 100));
            done();
        };
    };
    /**重命名 */
    var getUuid = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            })
            .toUpperCase();
    };
    var  getBuffer= async(url) =>{
        const fileName = 'pos/'+url.replace(/(.*\/)*([^.]+)/i, '$2');
        let result = await client.get(fileName);
        return result.content
    }
    return {
        upload: upload,
        uploadStream: uploadStream,
        uploadFileStream: uploadFileStream,
        getBuffer: getBuffer,
        uploadBlob: uploadBlob,
    };

}

  
export default aliupload;



// WEBPACK FOOTER //
// ./src/common/util/ossUploadServicePad.ts